"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawerLayout = void 0;
var react_1 = __importStar(require("react"));
var styles_1 = require("@mui/material/styles");
var prop_types_1 = __importDefault(require("prop-types"));
var DrawerLayoutContextProvider_1 = require("./contexts/DrawerLayoutContextProvider");
var css_1 = require("@emotion/css");
var Box_1 = __importDefault(require("@mui/material/Box"));
var DrawerLayoutClasses_1 = __importStar(require("./DrawerLayoutClasses"));
var base_1 = require("@mui/base");
var useUtilityClasses = function (ownerState) {
    var classes = ownerState.classes;
    var slots = {
        root: ['root'],
        content: ['content'],
        drawer: ['drawer'],
        expanded: ['expanded'],
    };
    return (0, base_1.unstable_composeClasses)(slots, DrawerLayoutClasses_1.getDrawerLayoutUtilityClass, classes);
};
var Root = (0, styles_1.styled)(Box_1.default, {})(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            display: 'flex',
            width: '100%',
            '&$expanded $content': {
                transition: theme.transitions.create('padding', {
                    duration: theme.transitions.duration.enteringScreen,
                }),
            }
        },
        _b["& .".concat(DrawerLayoutClasses_1.default.expanded)] = {},
        _b);
});
var Drawer = (0, styles_1.styled)(Box_1.default, {})(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'flex',
        position: 'fixed',
        height: '100%',
        alignItems: 'stretch',
        zIndex: theme.zIndex.drawer,
    });
});
var Content = (0, styles_1.styled)(Box_1.default, {})(function (_a) {
    var theme = _a.theme;
    return ({
        width: '100%',
        transition: theme.transitions.create('padding', { duration: theme.transitions.duration.leavingScreen }),
        zIndex: 0,
    });
});
var DrawerLayoutRender = function (props, ref) {
    var _a;
    var children = props.children, drawer = props.drawer, classes = props.classes, userClassName = props.className, otherProps = __rest(props, ["children", "drawer", "classes", "className"]);
    var theme = (0, styles_1.useTheme)();
    var _b = (0, react_1.useState)(0), padding = _b[0], setPadding = _b[1];
    var _c = (0, react_1.useState)(false), drawerOpen = _c[0], setDrawerOpen = _c[1];
    var defaultClasses = useUtilityClasses(props);
    var style = { paddingLeft: 0, paddingRight: 0 };
    style.paddingLeft = theme.direction === 'ltr' ? padding : 0;
    style.paddingRight = theme.direction === 'rtl' ? padding : 0;
    return (react_1.default.createElement(DrawerLayoutContextProvider_1.DrawerLayoutContext.Provider, { value: {
            setPadding: setPadding,
            setDrawerOpen: setDrawerOpen,
        } },
        react_1.default.createElement(Root, __assign({ ref: ref, className: (0, css_1.cx)(defaultClasses.root, classes.root, (_a = {},
                _a[defaultClasses.expanded] = drawerOpen,
                _a[classes.expanded] = drawerOpen,
                _a), userClassName) }, otherProps),
            react_1.default.createElement(Drawer, { className: (0, css_1.cx)(defaultClasses.drawer, classes.drawer) }, drawer),
            react_1.default.createElement(Content, { className: (0, css_1.cx)(defaultClasses.content, classes.content), style: style }, children))));
};
/**
 * [DrawerLayout](https://brightlayer-ui-components.github.io/react/components/drawer-layout) component
 *
 * The `<DrawerLayout>` component is used to provide the appropriate resizing behavior for your main application content when used in conjunction with a Brightlayer UI `<Drawer>`. It accepts a `<Drawer>` as a prop, and the main page content is passed in through child elements.
 */
exports.DrawerLayout = react_1.default.forwardRef(DrawerLayoutRender);
exports.DrawerLayout.displayName = 'DrawerLayout';
exports.DrawerLayout.propTypes = {
    classes: prop_types_1.default.shape({
        root: prop_types_1.default.string,
        content: prop_types_1.default.string,
        drawer: prop_types_1.default.string,
    }),
    drawer: prop_types_1.default.element.isRequired,
};
exports.DrawerLayout.defaultProps = {
    classes: {},
};
